export class Batch {
  static start = () => {};
}

export class BatchUser {
  static getInstallationID = () => {};
}

export class BatchProfile {
  static identify = () => {};
}

export class BatchPush {
  static registerForRemoteNotifications = () => {};
  static requestNotificationAuthorization = () => {};
}

export class BatchInbox {
  static fetchNotificationsForUserIdentifier = () => {};
}
